import type { FaireProductEntity } from "../../entity_types/product";

export const p_nfxwfss734: FaireProductEntity = {
  token: "p_nfxwfss734",
  type: "product",
  name: "Lotus Seeds Mala",
  brandToken: "b_ftaz83cznh",
  brandName: "Ancientveda",
  imageUrl:
    "https://cdn.faire.com/fastly/8c3cfb04b2d9b96737bcbc159dfea55821af84180566b4efae1df4239b254589.jpeg",
  galleryImageUrls: [],
  priceDollars: 8.31,
  description:
    "Indian mala beads, also known as prayer beads or japa malas, are a spiritual accessory used in meditation and prayer practices. Made from various materials such as rudraksha seeds, sandalwood, or gemstones, each bead represents a mantra or prayer repetition. Mala beads help in focusing the mind, promoting tranquility, and enhancing spiritual connection. They are worn or held while reciting prayers, enabling the practitioner to count repetitions. These sacred beads carry a profound significance in Indian spirituality, fostering mindfulness and deepening one's spiritual journey.",
  tags: [],
  msrpDollars: 20.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:14.906Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
